import React from 'react';
import styles from './WhatsAppButton.module.scss';

const WhatsAppButton = ({phone}) => {
  const number = phone ? phone.replace(/[^0-9]/g, '') : '6281188880811';
  const href = `https://wa.me/${number}`;
  return (
    <div className={styles.whatsapp_wrapper}>
      <a
        className={styles.whatsapp_btn}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <i className={["fab fa-whatsapp", styles.whatsapp_icon].join(' ')} aria-hidden="true" />
      </a>
    </div>
  )
}

export default WhatsAppButton;
